import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Landing } from './pages/Landing'
import { LoginPage } from './pages/LoginPage'
import { Terms } from './pages/Terms'
import { Privacy } from './pages/Privacy'
import { DashboardPage } from './pages/DashboardPage'
import { AdminAccessPage } from './pages/AdminAccessPage'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { DashboardLayout } from './components/layouts/DashboardLayout'
import { SigmaSpreadsheet } from './components/goals'
import { OnboardingFlow } from './components/onboarding'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        {/* Slug administrativa (não linkada na UI pública): gestão de acessos
            calux/sigma. Autentica com credenciais do admin-backend (JWT + 2FA). */}
        <Route path="/admin-access" element={<AdminAccessPage />} />

        {/* Protected Routes with DashboardLayout */}
        <Route
          element={
            <ProtectedRoute>
              <OnboardingFlow />
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/goals" element={<SigmaSpreadsheet />} />
          <Route
            path="/settings"
            element={
              <div>
                <h1 className="text-3xl font-bold tracking-tight mb-4">Configurações</h1>
                <p className="text-muted-foreground">Em desenvolvimento...</p>
              </div>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
